/* ----------------------------------------------------------------------------
   KLARNA MESSAGE UNDER THE CONFIGURATOR'S ADD TO CART  (Plush + Oak)
   ----------------------------------------------------------------------------
   sections/po-configurator.liquid renders EVERY app block into one fixed slot
   directly under the price, so Klarna's block cannot be positioned next to the
   button from the theme editor and a second Klarna block would only stack in
   that same slot. This adds a placement right after the add-to-cart form.

   That placement — its position — is now the ONLY thing this file does. The
   message, the amount, the term, the logo and the "Check purchase power"
   disclosure are all Klarna's, rendered by Klarna, untouched.

   ---------------------------------------------------------------------------
   KNOWN AND ACCEPTED: the figure is per product, not per build
   ---------------------------------------------------------------------------
   Klarna prices this placement from the PRODUCT, so a cart of three beds and
   three wraps still reads the one-bed monthly figure. Courtney knows and chose
   it, 2026-09-19: "Just put it back to how it was with the wrong total. Its
   better than this." The reasoning is that a clean, native-looking Klarna line
   converts better than a correct one that looks wrong, and the true amount is
   a tap away behind Klarna's own CTA and again at checkout.

   ⚠ The trade-off, on the record: a shopper building a $9,000 order sees a
   monthly figure for $2,597. If checkout abandonment moves, look here first.

   ---------------------------------------------------------------------------
   WHY THERE IS NO OVERRIDE ANY MORE — do not rebuild one
   ---------------------------------------------------------------------------
   There used to be. The placement was given the configurator's running total,
   which worked purely on ORDERING: Klarna's updater re-ran only in response to
   the configurator, never to our writes, so re-applying on a ladder of delays
   (400/900/1600/2600ms) meant ours landed last. Verified 2026-09-12.

   ⛔ Klarna changed their script. Measured 2026-09-19 on a settled page — no
   configurator interaction for four seconds, no refresh() call, one single
   attribute write — reverted within 500ms and stayed reverted. The write itself
   provokes the revert now, so there is no "last write" and a longer ladder
   cannot revive it. Our file was byte-identical to the one that worked.

   Everything tried since, and why each was rejected:

     - Re-assert via MutationObserver. Holds the number, but every correction
       provokes another Klarna re-render and their shadow CSS blurs the text in
       its `loading` state. Measured 21 re-renders per accessory toggle —
       correct figure, permanent flicker.

     - Suppress Klarna's sentence via ::part(osm-message) and print our own.
       Works mechanically, but renders in page body type with no Klarna logo,
       so it reads as our copy rather than theirs. It also asserted "0%
       interest", which Klarna does NOT claim on .ca — their Canadian line is
       "4 payments with Klarna" and the CTA there reads "Learn more".

     - Swap to Klarna's amount-free key (top-strip-promotion-auto-size) in the
       generic state. A probe suggested it renders "Pay later with Klarna", but
       that probe rendered BEFORE Klarna wrote an amount onto it. In real use
       Klarna writes the amount first and the placement then renders the credit
       promotion regardless of key — both placements showed the identical
       sentence. There is no amount-free placement to switch to.

   ⛔ NEVER hand-write the monthly figure. It is a regulated credit
   representation and we do not know Klarna's APR/term matrix. Measured
   $2,597 -> $125/mo and $2,944 -> $141/mo, roughly total ÷ 20.8 — not a clean
   24-month 0%, so it cannot be reproduced by arithmetic even if we wanted to.
   ---------------------------------------------------------------------------- */
(function () {
  if (window.__poKlarnaAtc) return;
  window.__poKlarnaAtc = true;

  /* Everything is copied from the app block; nothing is invented. */
  var COPIED = ['data-key', 'data-locale', 'data-theme'];
  var refreshTimer;

  /* Only ever called to get Klarna to render a placement we have just added or
     restyled. It is never called on a total change — we have no amount to push
     and asking Klarna to re-render would only make the line blink. */
  function refreshOnce() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () {
      var k = window.Klarna && window.Klarna.OnsiteMessaging;
      if (k && typeof k.refresh === 'function') k.refresh();
    }, 120);
  }

  function init(attempt) {
    if (document.getElementById('po-klarna-atc')) return;

    var source = document.querySelector('klarna-placement');
    var button = document.querySelector('.poc-atc');
    var form = button && button.closest('form');

    /* Klarna's block and the configurator both arrive asynchronously. */
    if (!source || !form) {
      if ((attempt || 0) < 20) setTimeout(function () { init((attempt || 0) + 1); }, 400);
      return;
    }

    var wrap = document.createElement('div');
    wrap.id = 'po-klarna-atc';
    wrap.style.marginTop = '10px';

    var placement = document.createElement('klarna-placement');

    function copyStatics() {
      for (var i = 0; i < COPIED.length; i++) {
        var value = source.getAttribute(COPIED[i]);
        if (value !== null) placement.setAttribute(COPIED[i], value);
      }
    }

    copyStatics();
    wrap.appendChild(placement);
    form.parentNode.insertBefore(wrap, form.nextSibling);
    refreshOnce();

    /* Locale and key can change with the market — .com renders "4 payments at
       0% interest … Check purchase power" while .ca renders "4 payments …
       Learn more". Following the app block keeps this line saying whatever
       Klarna says up the page. */
    if (window.MutationObserver) {
      new MutationObserver(function () {
        copyStatics();
        refreshOnce();
      }).observe(source, { attributes: true, attributeFilter: COPIED });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(0); });
  } else {
    init(0);
  }
})();